module.exports = __webpack_public_path__ + "img/f8d5a3d.jpg";